/**
 * @generated SignedSource<<d19be9a9001495591cc395ce127e2973>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type useJobApplication_User$data = {
  readonly status: UserStatus | null | undefined;
  readonly workingOrOfferedJob: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"user_useIsGuest">;
  readonly " $fragmentType": "useJobApplication_User";
};
export type useJobApplication_User$key = {
  readonly " $data"?: useJobApplication_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"useJobApplication_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useJobApplication_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workingOrOfferedJob",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsGuest"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "59fc8b08597a879a3d7f886578dda54e";

export default node;
